export default __webpack_public_path__ + "static/media/prio_3.37827430.svg";